import { useEffect, useState } from "react";

export const EstatusSelect = ({
  name,
  value,
  onChange,
  mostrar_motivo = false,
}) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-estatus"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="PE">Pendientes de envío</option>
      <option value="ME">Mensajes <embed src="" type="" />nviados</option>
      <option value="ER">Esperando respuesta</option>
      <option value="LE">Mensajes leidos</option>
      <option value="RL">Respuesta escrita</option>
      <option value="CI">Clientes con interes</option>
      <option value="SI">Clientes sin interes</option>
      {mostrar_motivo !== true && <option value="FP">Fecha programada</option>}
    </select>
  );
};
